import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'

interface RangeModel {
  numerator: { min: number; max: number }
  denominator: { min: number; max: number }
  factor: { min: number; max: number }
  variation: number
}

interface DifficultyLevelRangeMapModel {
  [key: number]: RangeModel
}

export interface FractionExpandQuestionModel {
  numerator: number
  denominator: number
  factor: number
  maxVariation: number
}

const DIFFICULTY_LEVEL_RANGE_MAP: DifficultyLevelRangeMapModel = {
  1: { numerator: { min: 1, max: 4 }, denominator: { min: 2, max: 5 }, factor: { min: 2, max: 2 }, variation: 10 },
  2: { numerator: { min: 0, max: 10 }, denominator: { min: 4, max: 10 }, factor: { min: 5, max: 5 }, variation: 20 },
  3: { numerator: { min: 0, max: 10 }, denominator: { min: 4, max: 10 }, factor: { min: 3, max: 3 }, variation: 20 },
  4: { numerator: { min: 0, max: 10 }, denominator: { min: 4, max: 10 }, factor: { min: 6, max: 10 }, variation: 30 },
}

export function getFractionExpandQuestion(difficultyLevel: number, excludes?: string[]): FractionExpandQuestionModel {
  const range = DIFFICULTY_LEVEL_RANGE_MAP[difficultyLevel]

  const factor = getRandomInt(range.factor.min, range.factor.max)
  const denominator = getRandomInt(range.denominator.min, range.denominator.max)
  const numerator = getRandomInt(range.numerator.min, denominator - 1)

  const key = `${factor}-${numerator}-${denominator}`
  if (excludes && excludes.includes(key)) return getFractionExpandQuestion(difficultyLevel, excludes)

  return { factor, denominator, numerator, maxVariation: range.variation }
}
